/**



 * Home recensioni: widget Judge.me v2025 se disponibile; altrimenti elenco totale metafield Judge.me.



 */



(function () {



  if (window.__eldraHomeReviewsBootBound) return;



  window.__eldraHomeReviewsBootBound = true;







  var hostSelector = '#judgeme_all_reviews_page.eldra-home-reviews__host';







  function hideLegacy(host) {



    if (!host) return;



    host.querySelectorAll('.jdgm-legacy-widget-content').forEach(function (node) {



      node.hidden = true;



      node.setAttribute('aria-hidden', 'true');



    });



  }







  function showLegacy(host) {



    if (!host) return;



    host.querySelectorAll('.jdgm-legacy-widget-content').forEach(function (node) {



      node.hidden = false;



      node.removeAttribute('aria-hidden');



    });



  }







  function hasModernWidget(host) {



    if (!host) return false;



    return !!host.querySelector(



      '.jdgm-all-reviews-widget-v2025, [class*="all-reviews-widget-v2025"], [data-jdgm-all-reviews-v2025]'



    );



  }







  function hasLegacyContent(host) {



    if (!host) return false;



    var legacy = host.querySelector('.jdgm-legacy-widget-content');



    if (!legacy) return false;



    return !!(



      legacy.querySelector('.jdgm-all-reviews__header, .jdgm-rev, .jdgm-all-reviews__body') ||



      legacy.textContent.trim()



    );



  }







  function isFullReviewsPage(host) {



    return !!(host && host.closest('.eldra-home-reviews--full'));



  }







  function preferLegacyOnFullPage(host) {



    host.classList.remove('eldra-home-reviews__host--ready');



    showLegacy(host);



    host.querySelectorAll('.jdgm-all-reviews-widget-v2025, [class*="all-reviews-widget-v2025"]').forEach(function (node) {



      node.hidden = true;



      node.setAttribute('aria-hidden', 'true');



      node.style.display = 'none';



    });



  }







  function sync() {



    var host = document.querySelector(hostSelector);



    if (!host) return;







    if (isFullReviewsPage(host)) {



      preferLegacyOnFullPage(host);



      return;



    }







    if (hasModernWidget(host)) {



      host.classList.add('eldra-home-reviews__host--ready');



      hideLegacy(host);



      return;



    }







    host.classList.remove('eldra-home-reviews__host--ready');



    if (hasLegacyContent(host)) {



      showLegacy(host);



    }



  }







  function scheduleSync() {



    sync();



    window.setTimeout(sync, 400);



    window.setTimeout(sync, 1200);



    window.setTimeout(sync, 2800);



  }

  function bindWriteReviewCtas() {
    document.querySelectorAll('.eldra-home-reviews__write-cta, [data-eldra-write-review]').forEach(function (node) {
      if (node.dataset.eldraWriteReviewClickBound) return;
      node.dataset.eldraWriteReviewClickBound = '1';
      var href = node.getAttribute('href') || '';
      if (href && href !== '#' && href !== '#eldra-judgeme-write-host') return;
      if (document.body.classList.contains('template-product')) {
        node.setAttribute('href', '#judgeme_product_reviews');
      } else if (document.getElementById('scrivi-recensione')) {
        node.setAttribute('href', '#scrivi-recensione');
      } else {
        node.setAttribute('href', '/pages/recensioni#scrivi-recensione');
      }
    });
  }







  document.addEventListener('DOMContentLoaded', scheduleSync);
  document.addEventListener('DOMContentLoaded', bindWriteReviewCtas);







  var host = document.querySelector(hostSelector);



  if (host && typeof MutationObserver !== 'undefined') {



    var observer = new MutationObserver(sync);



    observer.observe(host, { childList: true, subtree: true });



    window.setTimeout(function () {



      observer.disconnect();



      sync();



    }, 12000);



  }



})();


